module.exports = ".error-label {\n  padding-left: 5px;\n  color: #B45454; }\n\n:host ::ng-deep .ui-autocomplete-dropdown.ui-button-icon-only {\n  right: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/+app-custom/components/publication-registration/base-publication-form-part/publication-information-form-part/publication-information-form-part.component.scss
// module id = ./src/app/+app-custom/components/publication-registration/base-publication-form-part/publication-information-form-part/publication-information-form-part.component.scss
// module chunks = main